import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { CompanyService } from '../services/company.service';
import { EditButton, MarketDeleteButton } from '../util/buttons';
import { useModalConfirm } from '../hooks/useModalConfirm';
export function CompanyCardActionButtons(_ref) {
  let {
    model,
    accountType,
    setLoading,
    refreshCompanies,
    type,
    deleteCompanyGroup
  } = _ref;
  const deleteCompany = CompanyService.useDelete(model.id, () => {}, setLoading, model.name, refreshCompanies);
  const deleteSelectedCompanyGroup = useModalConfirm({
    type: 'delete',
    confirmationButtonText: model.name,
    onConfirm: () => deleteCompanyGroup(model.id)
  });
  const confirmDelete = () => {
    if (type === 'company') {
      deleteCompany();
      return;
    }
    deleteSelectedCompanyGroup();
  };
  const to = () => {
    if (type === 'company') {
      return `/${accountType}/companies/${model.id}/edit`;
    } else {
      return `/${accountType}/company_groups/${model.id}`;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex company-card-control"
  }, /*#__PURE__*/React.createElement(EditButton, {
    as: Link,
    to: to(),
    className: "p-1 d-inline-flex me-1"
  }), accountType === 'admin' && /*#__PURE__*/React.createElement(MarketDeleteButton, {
    className: "p-1 d-inline-flex",
    onClick: confirmDelete,
    "data-testid": "market-delete-button"
  }));
}